import Footer from "../Components/footer";
import Header from "../Components/Header";
import Form from "../Components/Form";
import React, { useState} from 'react';
import { useNavigate } from "react-router-dom";
import Faqaccordian from '../Components/Faqaccordian';
import CompanyLogoSlider from "../Components/CompanyLogoSlider";
import CustomSlider2 from "../Components/CustomSlider2";
import NewForm from "../Components/NewForm";
import CardSwiperSlider from "../Components/CardSwiperSlider";
import GoogleReviewsWidget2 from "../Components/GoogleReviewsWidget2";
import MoSlider from "../Components/MoSlider";
import { Helmet } from "react-helmet-async";
import CardSwiperSliderMobile from "../Components/CardSwiperSliderMobile";

const MobileDevlopmentPage = () =>  {

const sec5dot1 = "https://d3vqz9qyn2r1xe.cloudfront.net/imges/sec5dot1.png";
const sec5dot2 = "https://d3vqz9qyn2r1xe.cloudfront.net/imges/sec5dot2.png";
const sec5dot3 = "https://d3vqz9qyn2r1xe.cloudfront.net/imges/sec5dot3.png";
const sec5dot4 = "https://d3vqz9qyn2r1xe.cloudfront.net/imges/sec5dot4.png";
const stagesbg = "https://d3vqz9qyn2r1xe.cloudfront.net/imges/stagesbg.png";


const imagesCard = [
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/MoCard1.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/MoCard2.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/MoCard3.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/MoCard4.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/MoCard5.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/MoCard6.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/MoCard7.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/MoCard8.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/MoCard9.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/MoCard10.svg",
];
const MobileimagesCard = [
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard1.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard2.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard3.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard4.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard5.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard6.svg",
  // "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard7.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard8.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard9.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard10.svg",

 
];

const slidesData = [

{
  id: 1,
  title: "Salon at Home – Book Your Appointment for a Luxurious Experience!",
  description:"Enjoy a premium salon experience in the comfort of your home. Our expert beauticians bring top-quality services, from hairstyling and facials to manicures, pedicures, and more—tailored to your needs.",
  bgimage: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-img1.png", 
  bgcolor: 'rgba(255, 60, 115, 1)',
  btntext:'Visit Now',
  url:'https://www.lookplex.com/'
},
{
  id: 2,
  title: "Global Medical Community App",
  description:"A collaborative platform where doctors, medical professionals, and patients connect, share case studies, and manage health records in one place.",
  bgimage: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-img2.png", 
  bgcolor: 'rgba(0, 52, 164, 1)',
  btntext:'Download Now',
  url:'https://www.smartcare.health/'
},
{
  id: 3,
  title: "Appointment Booking & Queue Management App",
  description:"Effortlessly find and book services—doctors, salons, restaurants, spas—near you, all while skipping the wait with real-time queue updates.",
  bgimage: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-img3.png", 
  bgcolor: 'rgba(0, 161, 163, 1)',
  btntext:'Download Now'
},
{
  id: 4,
  title: "Journey of Miles: Tour & Travel App",
  description:"Explore and book curated travel packages across India. From hidden gems to popular destinations, plan your next adventure with ease.",
  bgimage: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-img4.png", 
  bgcolor: 'rgba(46, 155, 95, 1)',
  btntext:'Visit Now'
},
{
  id: 5,
  title: "Book Doctor Appointments Effortlessly – Anytime, Anywhere!",
  description:"Say goodbye to long waiting times and complicated booking processes! Our doctor appointment booking software makes it quick and easy to schedule consultations with trusted healthcare professionals.",
  bgimage: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-img5.png", 
  bgcolor: 'rgba(0, 163, 255, 1)',
  btntext:'Download Now'
},
{
  id: 6,
  title: "Clinic Management App",
  description:"Streamline your medical practice with comprehensive scheduling, patient record management, and secure communication—all in one user-friendly app.",
  bgimage: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-img6.png", 
  bgcolor: 'rgba(14, 39, 187, 1)',
  btntext:'Download Now'
},
];

const ratings = [
  {
    img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-img2.svg",
    rating: 4.9,
  },
  {
    img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/clutch_img1.svg",
    rating: 4.8,
  },
  {
    img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-img3.svg",
    rating: 4.6,
  },
  {
    img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/mob-add-img.png",
    rating: 4.4,
  },
  {
    img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/google-mo1.png",
    rating: 4.8,
  },
];




    // ================ Mailer code start from here =====================
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
        phone: "",
      });
      const [responseMessage, setResponseMessage] = useState(""); 
      const [loading, setLoading] = useState(false); // State for loader
      const navigate = useNavigate(); // Initialize useNavigate
      const [errors, setErrors] = useState({}); 
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value,
        });
      };
    
     
      const validateForm = () => {
        let formErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^[0-9]{10}$/; // Assumes phone number should be 10 digits
    
        if (!formData.email || !emailRegex.test(formData.email)) {
          formErrors.email = "Please enter a valid email address.";
        }
    
        if (!formData.phone || !phoneRegex.test(formData.phone)) {
          formErrors.phone = "Please enter a valid 10-digit phone number.";
        }
    
        if (!formData.message || formData.message.trim().length < 10) {
            formErrors.message = "Please enter a message with at least 10 characters.";
          }
    
        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!validateForm()) {
          return;
        }
        setLoading(true); // Show loader
    
        try {
          const response = await fetch(
            "https://mailer.datametricks.com/send-email.php",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            }
          );
    
          const result = await response.json(); // Parse JSON from the response
    
          setResponseMessage(result.message);
    
          if (result.status === "success") {
            setTimeout(() => {
              setLoading(false); // Hide loader
              navigate("/Successemailpage"); // Redirect to Thank You page
            }, 1000); // Delay redirect by 2 seconds
          } else {
            setLoading(false); // Hide loader if not successful
          }
        } catch (error) {
          setResponseMessage("Error submitting form.");
          setLoading(false); // Hide loader on error
        }
      };
    
      // ================ Mailer code end here =====================


 const ratingstar = "https://d3vqz9qyn2r1xe.cloudfront.net/imges/ratingstar.svg";



 
var faqDatamobile=[
    {que1:"1. What is mobile app development and why is it important?",ans1:"Mobile app development involves creating software applications that run on mobile devices. It's important because mobile apps can enhance customer engagement, provide better user experiences, and drive business growth by making your services accessible anytime, anywhere." },
    {que1:"2. How long does it take to develop a mobile app? ", ans1:"The timeline for developing a mobile app varies depending on the complexity and features of the app. A basic app might take a few months, while a more complex app with advanced features could take six months or longer."},
    {que1:"3. How much does it cost to develop a mobile app? ",ans1:"The cost of developing a mobile app depends on various factors, including the app's complexity, features, design, and the development team's rates. It's best to discuss your specific requirements with a development team to get an accurate estimate."},
    {que1:"4. What is the difference between native and cross-platform app development? ",ans1:"Native app development involves creating apps specifically for one platform (iOS or Android) using platform-specific languages and tools. Cross-platform app development allows you to create apps that run on multiple platforms (iOS and Android) using a single codebase, saving time and resources. "},
    {que1:"5. How do you ensure the security of my mobile app? ",ans1:"We prioritize app security by implementing best practices such as data encryption, secure APIs, regular security testing, and compliance with industry standards. Our team stays updated on the latest security trends to protect your app from vulnerabilities. "},
    {que1:"6. Can you integrate my mobile app with existing systems? ",ans1:"Yes, we offer app integration services that connect your mobile app with existing systems, databases, and third-party services to ensure seamless functionality and enhanced capabilities. "},
    {que1:"7. What kind of post-launch support do you provide?",ans1:"We provide comprehensive post-launch support, including regular updates, bug fixes, performance optimization, and ongoing maintenance to ensure your app remains functional and up to date. " },
    {que1:"8. How do you handle app updates and maintenance? ",ans1:"We offer ongoing maintenance services to keep your app updated with the latest features and security patches. Our team monitors the app's performance and user feedback to make necessary improvements and ensure optimal functionality. " },
    {que1:"9. Can you help with app store submissions? ",ans1:"Yes, we assist with the entire app store submission process, including preparing necessary documentation, ensuring compliance with app store guidelines, and managing the submission to both Apple App Store and Google Play Store. "},
    {que1:"10. Why should I choose DataMetricks for my mobile app development? ",ans1:"DataMetricks Consulting offers expert mobile app development services tailored to your business needs. Our team has extensive experience, a proven track record of successful projects, and a commitment to delivering high-quality, user-centric apps. We provide end-to-end services, from initial strategy and design to development, testing, and ongoing support. "},    

];

return(



    <div>

    <Helmet>
        <title>Expert Mobile App Development Services | Custom iOS & Android Apps | DataMetricks</title>
        <meta name="description" content="Transform your vision into powerful mobile apps with our expert team. Specializing in iOS, Android & cross-platform solutions. Contact us today" />
      </Helmet>


        <section>
                <Header/>
               
        </section>

        <section >
            <div   style={{backgroundColor:'#EDEDED'}}>
                <div className="container" style={{paddingBottom:'35px'}}>

              {/* <div className="justify-content-center d-flex fixed-top mt-10 px-1">
              <div className="MoNavClass  mb-lg-5 ">          
            <div className="d-flex justify-content-between" >
            <a href="#">
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/DM-White-Logo.png" alt="" className="img-fluid Mo-logo-img"  style={{width:'226px',height:'42px'}}/>
                </a>
                <a href="#formsection">
                <button class="btn hoverclass" type="submit" style={{backgroundColor:'rgba(255, 255, 255, 1)',fontSize:'18px',fontWeight:'700'}}>Let’s Talk</button>
                </a>
          </div>
                </div>
              </div> */}

                    <div className="row justify-content-center paddingt-35" style={{paddingTop:'10%'}}>
                        <div className="col-lg-7 col-12">
                        <p className="fw-800 fs-55 plus mb-0  font-28 lineheight" style={{color:'rgba(0, 83, 154, 1)',lineHeight:'72px'}}> Trusted Mobile App Development Company in India </p>

                            <p className="fw-500 fs-17 plus pt-lg-4 pt-20 hideinmo" style={{color:'rgba(0, 0, 0, 0.7)'}}> As a leading Mobile App Development Company in India, we develop scalable and robust applications tailored to grow with your business. Let’s create a mobile app your customers will love, driving your business to new heights. </p>

               <div className="hideinmo">
                <p className="fs-20 fw-700 plus pt-3" style={{color:'rgba(0, 83, 154, 1)'}}>Our Impact and Recognition</p>


<div className="row gap-3 mt-lg-5">
  {ratings.map((item, index) => (
    <div key={index} className="col-md-2 col-6 d-flex justify-content-center">
      <div
        className="d-flex flex-column align-items-center "
        style={{
          width: "150px",
          height: "180px",
        
        }}
      >
        <img
          src={item.img}
          alt="rating-img"
          className="img-fluid"
          style={{ width: "100%", height: "100px", objectFit: "contain" }}
        />

        <div className="mt-2 d-flex align-items-center justify-content-center">
          <span className="fs-5 fw-bold text-dark">{item.rating}</span>
          <img
            src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png"
            alt="star-icon"
            style={{ width: "60px", marginLeft: "5px" }}
          />
        </div>
      </div>
    </div>
  ))}
</div>

              


               </div>
                        </div>


                        <div className="col-lg-5 col-12  mt-10">

                          <div style={{position:'relative'}}>
                            <div className="hideinmo">
                          <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/mobile-img-1.svg" alt="" className="img-fluid" />
                          </div>

                          <div className="hideinmo" style={{position:'absolute',left:'0',right:'0',bottom:'0',top:'50%'}}>
                          <form onSubmit={handleSubmit}>
                            <div className="px-4 pt-3 pb-4" style={{boxShadow:'0px 0px 4px 0px rgba(0, 0, 0, 0.25)', backgroundColor:'rgba(244, 250, 255, 1)',borderRadius:'24px'}}>
                               <p className="fs-28 fw-700 pop mb-0 font-20" style={{color:'rgba(27, 27, 27, 1)'}}>Ready to Start Your Project?</p>
                               <p className="fw-700 fs-25 pop pt-1 font-20" style={{color:'rgba(0, 83, 154, 1)'}}>Get a Free Quote</p>

                               <div >
                                <input className="w-100"
                                
                                type="text" placeholder="Name*" 
                                id="fname"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              required
                                style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                               </div>

                    <div className="mt-4 row">
                      <div className="col-md-6">
                               <div >
                                <input className="w-100" type="tel"
                                  name="phone"  
                                  value={formData.phone}
                                  onChange={handleChange}  
                                  required                
                                  placeholder="Mobile Number*" style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                                  {errors.phone && (
                        <p
                          className="error-text"
                          style={{
                            fontSize: "12px",
                            color: "red",
                            marginTop: "10px",
                          }}
                        >
                          {errors.phone}
                        </p>
                      )}
                               </div>
                               </div>

                               <div className="col-md-6">

                               <div >
                                <input className="w-100" type="email"
                                 id="email" name="email"  value={formData.email}
                                 onChange={handleChange}
                                 required
                                placeholder="Email*" style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                           {errors.email && <p className="error-text" style={{ fontSize: "12px", color: "red", marginTop: "5px" }}>{errors.email}</p>}

                               </div>
                               </div>

                               </div>

                               <div className="mt-4" >
                                <input className="w-100" type="text" placeholder="Message..."
                                 name="message"  value={formData.message}
                                 onChange={handleChange}
                                 form="usrform"
                                 required
                                style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                         {errors.message && (<p className="error-text" style={{ fontSize: "12px", color: "red", marginTop: "5px" }} > {errors.message} </p>)}

                               </div>
                          
                               <div className="mt-5" >
                               <button type="submit" className="btn btn-sm w-100" disabled={loading} style={{fontSize:'20px',fontWeight:'600',backgroundColor:'rgba(27, 27, 27, 1)',color:'white',borderRadius:'50px',border:'none',outline:'none',padding:'12px 60px 12px 60px'}}>
                        {loading ? (
                                    <>
            
                         <div className="spinner"></div>
                
                              </>
                          ) : (
                                "Submit"
                              )}

                         </button>
                               </div>
                            </div>
                          </form>
                          </div>

                          </div>

                           
                          <div className="hideindesktop">
                          <form onSubmit={handleSubmit}>
                            <div className="px-4 pt-3 py-4" style={{boxShadow:'0px 0px 4px 0px rgba(0, 0, 0, 0.25)', backgroundColor:'rgba(244, 250, 255, 1)',borderRadius:'24px'}}>
                               <p className="fs-28 fw-700 pop mb-0 font-22" style={{color:'rgba(27, 27, 27, 1)'}}>Ready to Start Your Project?</p>
                               <p className="fw-700 fs-25 pop pt-1 font-20" style={{color:'rgba(0, 83, 154, 1)'}}>Get a Free Quote</p>

                               <div >
                                <input className="w-100"
                                
                                type="text" placeholder="Name*" 
                                id="fname"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              required
                                style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                               </div>

                    <div className="mt-4 row">
                      <div className="col-md-6">
                               <div >
                                <input className="w-100" type="tel"
                                  name="phone"  
                                  value={formData.phone}
                                  onChange={handleChange}  
                                  required                
                                  placeholder="Mobile number*" style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                                  {errors.phone && (
                        <p
                          className="error-text"
                          style={{
                            fontSize: "12px",
                            color: "red",
                            marginTop: "10px",
                          }}
                        >
                          {errors.phone}
                        </p>
                      )}
                               </div>
                               </div>

                               <div className="col-md-6 pt-4">

                               <div >
                                <input className="w-100" type="email"
                                 id="email" name="email"  value={formData.email}
                                 onChange={handleChange}
                                 required
                                placeholder="Email*" style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                           {errors.email && <p className="error-text" style={{ fontSize: "12px", color: "red", marginTop: "5px" }}>{errors.email}</p>}

                               </div>
                               </div>

                               </div>

                               <div className="mt-4" >
                                <input className="w-100" type="text" placeholder="Message..."
                                 name="message"  value={formData.message}
                                 onChange={handleChange}
                                 form="usrform"
                                 required
                                style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                         {errors.message && (<p className="error-text" style={{ fontSize: "12px", color: "red", marginTop: "5px" }} > {errors.message} </p>)}

                               </div>
                          
                               <div className="mt-4" >
                               <button type="submit " className="btn btn-sm w-100" disabled={loading} style={{fontSize:'20px',fontWeight:'600',backgroundColor:'rgba(27, 27, 27, 1)',color:'white',borderRadius:'50px',border:'none',outline:'none',paddingBottom:'6px'}}>
                        {loading ? (
                                    <>
            
                         <div className="spinner"></div>
                
                              </>
                          ) : (
                                "Submit"
                              )}

                         </button>
                               </div>
                            </div>
                          </form>
                          </div>

                         
                          
                        </div>
                       
                       
                    </div>

                    <div className="hideindesktop">
  <p
    className="fs-20 fw-700 plus pt-3"
    style={{ color: "rgba(0, 83, 154, 1)" }}
  >
    Our Impact and Recognition
  </p>
  <div
    className="d-flex justify-content-between align-items-center mt-3"
    style={{ gap: "10px" }} 
  >
    {/* Box 1 */}
    <div className="text-center">
      <img
        src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-logo1.png"
        alt="box-img"
        className="img-fluid"
        style={{ width: "60px", height: "60px", objectFit: "contain" }} 
      />
      <div className="fs-14 fw-700" style={{ color: "rgba(58, 58, 58, 1)" }}>
        4.9{" "}
        <img
          src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png"
          alt="star"
          style={{ width: "50px", height: "auto" }}
        />
      </div>
    </div>

    {/* Box 2 */}
    <div className="text-center">
      <img
        src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-logo2.png"
        alt="box-img"
        className="img-fluid"
        style={{ width: "60px", height: "60px", objectFit: "contain" }}
      />
      <div className="fs-14 fw-700" style={{ color: "rgba(58, 58, 58, 1)" }}>
        4.8{" "}
        <img
          src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png"
          alt="star"
          style={{ width: "50px", height: "auto" }}
        />
      </div>
    </div>

    {/* Box 3 */}
    <div className="text-center">
      <img
        src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-logo3.png"
        alt="box-img"
        className="img-fluid"
        style={{ width: "60px", height: "60px", objectFit: "contain" }}
      />
      <div className="fs-14 fw-700" style={{ color: "rgba(58, 58, 58, 1)" }}>
        4.6{" "}
        <img
          src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png"
          alt="star"
          style={{ width: "50px", height: "auto" }}
        />
      </div>
    </div>

    {/* Box 4 */}
    <div className="text-center">
      <img
        src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-logo4.png"
        alt="box-img"
        className="img-fluid"
        style={{ width: "60px", height: "60px", objectFit: "contain" }}
      />
      <div className="fs-14 fw-700" style={{ color: "rgba(58, 58, 58, 1)" }}>
        4.8{" "}
        <img
          src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png"
          alt="star"
          style={{ width: "50px", height: "auto" }}
        />
      </div>
    </div>
  </div>
</div>

                </div>
              
            </div>
        </section>

<div className="d-flex justify-content-center mt-30">
        <div className="px-3 pb-1  mt0 " style={{width:'max-content',borderRadius:'6px',marginTop:'60px',backgroundColor:'rgba(35, 35, 35, 1)', border:'1px solid rgba(255, 255, 255, 1)',paddingTop:'2px'}}>
              <div className="fs-30 fw-700 plus text-center newfont-18" style={{color:'rgba(255, 255, 255, 1)'}}> Trusted by Top-Tier Clients </div>
              </div>
              </div>

        <section className=" ">

    <div className=" pt-3 pb-4 mt-4" style={{backgroundColor:'white',boxShadow: '0px 0px 7.3px 0px rgba(175, 175, 175, 0.25)'}}>
        <div style={{overflow:'hidden'}}>
            <div className="row  justify-content-center">  
             
 
                <div className="col-lg-12 py-3 ">
                    <CompanyLogoSlider/>
                </div>
            </div>
        </div>

    </div>

</section>


<section >
    {/* <section>
       <div className='container textcenter text-center  mt-lg-4 mt-20'>
            <p className='fw-600 fs-35 plus mb-0 font-23'>Our Success Stories Transformative</p>
            <p className='fw-600 fs-35 plus font-23 '>Projects and <span style={{color:'rgba(0, 83, 154, 1)'}}>Case Studies </span></p>
       </div>
    </section> */}

    <section className="mt0 " style={{marginTop:'60px'}}>
    <div className="container-fluid mt-30">

      <p className="fs-35 fw-800 plus text-center font-25 mb-0">A Glimpse of Our Recent Work</p>

        <div className="row justify-content-center mt-10">
            <div className="col-lg-12">
              <CustomSlider2 slidesdata={slidesData}/>

            </div>
        </div>
    </div>


</section>
</section>

     

        <section className=" mt-lg-2 mt-30" >
    <div className="container pb-lg-5 ">
        <p className="fw-800 fs-35 plus text-center mb-0 font-23" style={{color:'#1B3567'}}>India's One Of The Highest Rated Mobile App Development Company</p>
        <p className="fw-500 fs-20 plus text-center pt-2 font-18" style={{color:'#1B3567'}}> 100+ Glowing 5-Star Reviews Across Top B2B Review Platforms</p>

        <div className="row justify-content-center mt-4 g-2 p-10" >

            <div className="col-lg-2 col-md-2 col-6 text-center">
                <div className="p-2 h-100" style={{border:'1px solid #C7D6E3',borderRadius:'9px',backgroundColor:'#FFFFFF'}}>
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/clutch_img1.svg" alt="box-img" style={{height:'100px',width:'100%'}} className="img-fluid  "  />
                    {/* <img src={ratingstar} alt="" className="pt-2  "  /> */}
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png" alt="" className="pt-2  "  style={{width:'110px'}} />

                    <p className="fw-700 fs-32 mont font-23 pt-2" >4.8</p>
                                  

                </div>
            </div>
            <div className="col-lg-2 col-md-2 col-6 text-center">
                <div className="p-2 h-100" style={{border:'1px solid #C7D6E3',borderRadius:'9px',backgroundColor:'#FFFFFF'}}>
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-img2.svg" alt="box-img" style={{height:'100px',width:'100%'}} className="img-fluid  "  />
                    {/* <img src={ratingstar} alt="" className="pt-2  "   /> */}
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png" alt="" className="pt-2  "  style={{width:'110px'}} />

                    <p className="fw-700 fs-32 mont font-23 pt-2" >4.9</p>
                                  

                </div>
            </div>

            <div className="col-lg-2 col-md-2 col-6 text-center">
                <div className="p-2 h-100" style={{border:'1px solid #C7D6E3',borderRadius:'9px',backgroundColor:'#FFFFFF'}}>
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-img3.svg" alt="box-img" style={{height:'100px',width:'100%'}} className="img-fluid heightwidth2" />
                    {/* <img src={ratingstar} alt="" className="pt-2"  /> */}
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png" alt="" className="pt-2  "  style={{width:'110px'}} />

                    <p className="fw-700 fs-32 mont font-23 pt-2" >4.6</p>
                </div>
            </div>

            <div className="col-lg-2 col-md-2 col-6 text-center">
                <div className="p-2 h-100" style={{border:'1px solid #C7D6E3',borderRadius:'9px',backgroundColor:'#FFFFFF'}}>
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-img4.svg" alt="box-img" style={{height:'100px',width:'100%'}} className="img-fluid heightwidth2" />
                    {/* <img src={ratingstar} alt="" className="pt-2"  /> */}
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png" alt="" className="pt-2  "  style={{width:'110px'}} />

                    <p className="fw-700 fs-32 mont font-23 pt-2" >4.4</p>
                </div>
            </div>

            <div className="col-lg-2 col-md-2 col-6 text-center">
                <div className="p-2 h-100 " style={{border:'1px solid #C7D6E3',borderRadius:'9px',backgroundColor:'#FFFFFF'}}>
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-logo4.png" alt="box-img" style={{height:'100px',width:'75%',objectFit:'contain'}} className="img-fluid  " />

                    {/* <img src={ratingstar} alt="" className="pt-2"   /> */}
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png" alt="" className="pt-lg-2  "  style={{width:'110px'}} />

                    <p className="fw-700 fs-32 mont font-23 pt-2" >4.8</p>
                </div>
            </div>
            <div className="col-lg-2 col-md-2 col-6 text-center">
                <div className="p-2 h-100" style={{border:'1px solid #C7D6E3',borderRadius:'9px',backgroundColor:'#FFFFFF'}}>
                    
                    <div>
                        <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/mob-add-img.png" alt="box-img" style={{height:'100px',width:'75%',objectFit:'contain'}} className="img-fluid" />

                        </div>
                    {/* <img src={ratingstar} alt="" className="pt-2"  /> */}
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png" alt="" className="pt-lg-2  "  style={{width:'110px'}} />

                    <p className="fw-700 fs-32 mont font-23 pt-2" >4.4</p>
                </div>
            </div>

          
        </div>

    </div>

</section>



<section >
            <div className="mt-20 " >
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 text-center">
                      
                       <p className="fw-800 fs-35 plus  font-22 " style={{color:'rgba(0, 0, 0, 1)'}}>Mobile Application Development Services for Various Platforms</p>  
                       <p className="fw-500 fs-16 plus" style={{color:'rgba(0, 0, 0, 0.6)'}}>Our mobile app developers have over a decade-long expertise in building solutions that meet market needs, empower companies’ brand identity, and encourage business growth and expansion.</p>                   
                     </div>
              
                 </div>

            <div className="row justify-content-center  mt-lg-3 g-0 g-2 pt-10 textcenter">
                <div className="col-lg-4 col-12 col-md-3 ">

                      <div className="px-4 pt-3 " style={{borderRadius:'17px',boxShadow:'0px 0px 4px 0px rgba(0, 0, 0, 0.25)'}}>
                            {/* <div className="d-flex gap-2">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/mo-icon-1.svg" alt="" />
                                </div> */}
                                <div>
                                    <p className="fw-700 fs-18 plus font-15 mb-0 " >iOS App Development</p>
                                </div>
                           {/* </div> */}
                           <p className="fw-500 fs-14 plus pt-2 hideinmo " style={{color:'rgba(0, 0, 0, 0.7)'}}>As a leading iOS App Development Company, our team ensures seamless integration with the  Apple ecosystem, delivering flawless user experience. Leveraging the latest technologies and  customized features, we develop iOS apps that align with your business goals and surpass user  expectations.</p>
                       <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-bg1.png" alt="" className="img-fluid  mt-20" />
                    </div>

                </div>

                        <div className="col-lg-4 col-12 col-md-3">

                        <div className="px-4 pt-3 h-100 " style={{borderRadius:'17px',boxShadow:'0px 0px 4px 0px rgba(0, 0, 0, 0.25)'}}>
                            {/* <div className="d-flex gap-2">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/mo-icon-1.svg" alt="" />
                                </div> */}
                                <div>
                                    <p className="fw-700 fs-18 plus font-15 mb-0" >Android App Development</p>
                                </div>
                           {/* </div> */}
                           <p className="fw-500 fs-14 plus pt-2 hideinmo" style={{color:'rgba(0, 0, 0, 0.7)'}}>Our team specializes in building custom Android software that places your business at the forefront of any modern Android device. Our Android app development services ensure your app stands out in a competitive market and delivers a seamless, engaging, and high-performance user experience.</p>
                           <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-bg2.png" alt="" className="img-fluid  " />

                    </div>
                       
                        </div>

                        <div className="col-lg-4 col-12 col-md-3">

<div className="px-4 pt-3 h-100" style={{borderRadius:'17px',boxShadow:'0px 0px 4px 0px rgba(0, 0, 0, 0.25)' }}>
      {/* <div className="d-flex gap-2">
          <div>
              <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/mo-icon-2.svg" alt="" />
          </div> */}
          <div>
              <p className="fw-700 fs-18 plus font-15 mb-0" >Wearables and Embedded Software</p>
          </div>
     {/* </div> */}
     <p className="fw-500 fs-14 plus pt-2 hideinmo" style={{color:'rgba(0, 0, 0, 0.7)'}}>Our Wearables and Embedded Software solutions are designed to seamlessly integrate with modern devices, enhancing functionality and user experience. We create innovative, reliable software that powers wearable technology and embedded systems, helping your business stay ahead in a rapidly evolving market.</p>
     <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-bg3.png" alt="" className="img-fluid  mt-20" />

</div>

</div>
              
                 </div>

                 <div className="row justify-content-center g-0 g-2 textcenter" style={{paddingTop:'8px'}}>
                <div className="col-lg-4 col-12 col-md-3">

                      <div className="px-4 pt-3 h-100" style={{borderRadius:'17px',boxShadow:'0px 0px 4px 0px rgba(0, 0, 0, 0.25)'}}>
                            {/* <div className="d-flex gap-2">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/mo-icon-4.svg" alt="" />
                                </div> */}
                                <div>
                                    <p className="fw-700 fs-18 plus font-15 mb-0" >Cross-Platform Apps</p>
                                </div>
                           {/* </div> */}
                           <p className="fw-500 fs-14 plus pt-2 hideinmo" style={{color:'rgba(0, 0, 0, 0.7)'}}>Our cross-platform app development ensures your app works smoothly on both iOS and Android. With a single codebase, faster deployment, and seamless performance, cross-platform apps are cost-effective, scalable, and easy to maintain, making them a versatile, future-ready, and efficient addition to your business.</p>
                           <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-bg4.png" alt="" className="img-fluid  mt-05" />

                    </div>

                </div>

                        <div className="col-lg-4 col-12 col-md-3 ">

                        <div className="px-4 pt-3 h-100" style={{borderRadius:'17px',boxShadow:'0px 0px 4px 0px rgba(0, 0, 0, 0.25)' }}>
                            {/* <div className="d-flex gap-2">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/mo-icon-4.svg" alt="" />
                                </div> */}
                                <div>
                                    <p className="fw-700 fs-18 plus font-15 mb-0" >Progressive Web Apps</p>
                                </div>
                           {/* </div> */}
                           <p className="fw-500 fs-14 plus pt-2 hideinmo" style={{color:'rgba(0, 0, 0, 0.7)'}}> We build Progressive Web Apps that combine the best of web and mobile apps, offering fast, reliable, and engaging user experiences across all platforms with offline capabilities, push notifications, seamless performance, responsive design, enhanced security, improved accessibility, cross-device compatibility, and superior scalability. </p>
                           <div>
                           <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-bg5.png" alt="" className="img-fluid  mt-20" />
                           </div>
                    </div>
                       
                        </div>
              
                 </div>

                 <div className="text-center mt-4">
                 <a href="#formsection">
                    <button type="button" className="btn btn-sm font-14  pt-2  px-5 text-white hoverclass" style={{fontSize:'20px',fontWeight:'600',backgroundColor:'rgba(0, 0, 0, 1)',borderRadius:'45px',border:'none',outline:'none',paddingBottom:'10px'}}>
                    Get in Touch
                    </button>
                </a>
                 </div>

              </div>
            </div>
        </section>



        <section className="pb-5 pt-4 mt-5" style={{backgroundColor:'rgba(232, 252, 255, 1)'}}>

  <div>
         <p className="fw-800 fs-35 plus font-25 text-center plr-10" style={{color:'rgba(0, 0, 0, 1)'}}>Over 150 Apps Delivered Across Various Industries – Fueling Success</p>  
         <p className="fw-500 fs-16 plus text-center plr-20" style={{color:'rgba(0, 0, 0, 0.6)'}}>We develop apps that feels tailor-made for your customers. Every tap, every update, every order—crafted to give them <br/> an experience they’ll return to time and again.</p>                   
   
  </div>



  <div className="hideinmo">
 <CardSwiperSlider  imagesData={imagesCard}/>
 </div>

 <div className="hideindesktop">
 <CardSwiperSliderMobile   mobileimageData={MobileimagesCard}/>
 </div>

</section>


<section>
  <div className="container mt-lg-5 mt-10">
    <div className="row justify-content-center align-items-center">
      <div className="col-lg-5 textcenter">
        <p className="fs-40 fw-800 plus font-25" style={{color:'rgba(0, 83, 154, 1)'}}>What Makes DataMetricks Stand Out?</p>
        <a href="#formsection">
                    <button type="button" className="btn btn-sm font-14    px-4" style={{fontSize:'18px',fontWeight:'700',borderRadius:'45px',border:'1.5px solid rgba(0, 83, 154, 1)',outline:'none',color:'rgba(0, 83, 154, 1)'}}>
                    Get a Free Quote
                    </button>
         </a>
      </div>


      <div className="col-lg-6 mt-30">
        <div className="row g-2 ">
          <div className="col-md-6">
            <div className="pt-3 pb-1 px-4 h-100" style={{backgroundColor:'rgba(255, 235, 226, 1)',borderRadius:'27px'}}>
                <p className="fw-600 fs-20 plus mb-0">Successful Projects</p>
                <p className="fs-16 fw-400 plus pt-2 mb-0" style={{color:'rgba(0, 0, 0, 0.7)'}}>Proven track record of delivering high-quality solutions across various industries.</p>
                <p className="fw-800 fs-40 plus pt-1 font-25" style={{color:'rgba(180, 84, 40, 1)'}}>100+</p>
            </div>

          </div>
          <div className="col-md-6">
            <div className="pt-3 pb-1 px-4 h-100" style={{backgroundColor:'rgba(232, 252, 255, 1)',borderRadius:'27px'}}>
                <p className="fw-600 fs-20 plus mb-0">Skilled Developers</p>
                <p className="fs-16 fw-400 plus pt-2 mb-0" style={{color:'rgba(0, 0, 0, 0.7)'}}>A dedicated team of professionals with expertise in cutting-edge technologies.</p>
                <p className="fw-800 fs-40 plus pt-1 font-25" style={{color:'rgba(62, 156, 170, 1)'}}>30+</p>
            </div>

          </div>

        </div>

        <div className="row pt-2">
          <div className="col-md-12">
            <div className="pt-3 pb-1 px-4 " style={{backgroundColor:'rgba(240, 250, 240, 1)',borderRadius:'27px'}}>
                <p className="fw-600 fs-20 plus mb-0">Client Satisfaction</p>
                <p className="fs-16 fw-400 plus pt-2 mb-0" style={{color:'rgba(0, 0, 0, 0.7)'}}>Commitment to excellence, ensuring top-tier service and customer success.</p>
                <p className="fw-700 fs-40 plus pt-1 font-25" style={{color:'rgba(93, 169, 93, 1)'}}>4.8 Google Ratings</p>
            </div>
          </div>
          </div>

</div>

    </div>

  </div>
</section>


<section>
  <div className="container mt-lg-5 mt-30">
 
                      <div className="text-center">
                      <p className="fw-800 fs-35 plus newfont-24 " style={{color:'rgba(0, 0, 0, 1)'}}>Industries We Specialize In for Mobile App Development Solutions</p>  

                      </div>
                       <p className="fw-500 fs-16 plus text-center" style={{color:'rgba(0, 0, 0, 0.6)'}}>From startups to enterprises, we’ve gained vast experience in delivering innovative digital solutions for a wide range of clients across multiple industries.</p>                   
              
               <div className="row justify-content-center mt-lg-5 mt-30">
                <div className="col-lg-10 col-8">

                 

               
        <div className="row justify-content-center hideinmo">

                    <div className="col-md-2 col-4 text-center">
                        <div><img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-icon7.png" alt="" style={{height:'70px',width:'70px'}} /> </div>
                        <div className="fw-700 fs-17 plus hideinmo pt-2" style={{color:'rgba(79, 79, 79, 1)'}}>Construction <br/>
                        & Interior</div>


                    </div>

                    <div className="col-md-2  col-4 text-center">
                        <div><img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-icon8.png" alt="" style={{height:'70px',width:'70px'}} /> </div>
                        <div className="fw-700 fs-17 plus hideinmo pt-2" style={{color:'rgba(79, 79, 79, 1)'}}>Insurance <br/> & Finance </div>


                    </div>

                    <div className="col-md-2  col-4 text-center">
                        <div><img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-icon9.png" alt="" style={{height:'70px',width:'70px'}} /> </div>
                        <div className="fw-700 fs-17 plus hideinmo pt-2" style={{color:'rgba(79, 79, 79, 1)'}}>Tour &<br/> Travel</div>


                    </div>

                    <div className="col-md-2 col-4 text-center">
                        <div><img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-icon6.png" alt="" style={{height:'70px',width:'70px'}} /> </div>
                        <div className="fw-700 fs-17 plus hideinmo pt-2" style={{color:'rgba(79, 79, 79, 1)'}}>Transport and Logistics</div>


                    </div>
                    </div>


                    <div className="row justify-content-center mt-5 hideinmo">
                    <div className="col-md-2 col-4 text-center">
                        <div><img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-icon1.png" alt="" style={{height:'70px',width:'70px'}} /> </div>
                        <div className="fw-700 fs-17 plus hideinmo pt-2" style={{color:'rgba(79, 79, 79, 1)'}}>Healthcare <br/> & Medical</div>

                    

                    </div>

                    <div className="col-md-2 col-4 text-center">
                        <div><img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-icon2.png" alt="" style={{height:'70px',width:'70px'}} /> </div>
                        <div className="fw-700 fs-17 plus hideinmo pt-2" style={{color:'rgba(79, 79, 79, 1)'}}>eCommerce <br/> & Retail</div>


                    </div>

                    <div className="col-md-2 col-4 text-center">
                        <div><img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-icon4.png" alt="" style={{height:'70px',width:'70px'}} /> </div>
                        <div className="fw-700 fs-17 plus hideinmo pt-2" style={{color:'rgba(79, 79, 79, 1)'}}>Education <br/>
                        & LMS</div>


                    </div>

                    <div className="col-md-2 col-4 text-center ">
                        <div><img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-icon5.png" alt="" style={{height:'70px',width:'70px'}} /> </div>
                        <div className="fw-700 fs-17 plus hideinmo pt-2" style={{color:'rgba(79, 79, 79, 1)'}}>Social Media <br/>
                        & Community </div>


                    </div>

                  
                  </div>

      

                </div>
               </div>



               <div className="row justify-content-center  ">
               <div className="col-12 hideindesktop">

               <div className="row justify-content-center text-center">

<div className="col-4 ">
    <div><img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-icon7.png" alt="" style={{height:'70px',width:'70px'}} /> </div>
    <div className="fw-700 fs-14 plus  pt-2" style={{color:'rgba(79, 79, 79, 1)'}}>Construction <br/>
    & Interior</div>

</div>

<div className="col-4">
    <div><img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-icon8.png" alt="" style={{height:'70px',width:'70px'}} /> </div>
    <div className="fw-700 fs-14 plus  pt-2" style={{color:'rgba(79, 79, 79, 1)'}}>Insurance <br/> & Finance </div>


</div>

<div className="col-4">
    <div><img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-icon9.png" alt="" style={{height:'70px',width:'70px'}} /> </div>
    <div className="fw-700 fs-14 plus  pt-2" style={{color:'rgba(79, 79, 79, 1)'}}>Tour &<br/> Travel</div>


</div>


</div>


<div className="row justify-content-center mt-4 text-center">
<div className=" col-4 ">
    <div><img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-icon6.png" alt="" style={{height:'70px',width:'70px'}} /> </div>
     <div className="fw-700 fs-14 plus  pt-2" style={{color:'rgba(79, 79, 79, 1)'}}>Transport and Logistics</div>


</div>

<div className=" col-4 ">
    <div><img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-icon1.png" alt="" style={{height:'70px',width:'70px'}} /> </div>
    <div className="fw-700 fs-14 plus pt-2" style={{color:'rgba(79, 79, 79, 1)'}}>Healthcare <br/> & Medical</div>



</div>

<div className=" col-4 ">
    <div><img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-icon2.png" alt="" style={{height:'70px',width:'70px'}} /> </div>
    <div className="fw-700 fs-14 plus pt-2" style={{color:'rgba(79, 79, 79, 1)'}}>eCommerce <br/> & Retail</div>


</div>

</div>

<div className="row justify-content-center mt-4 text-center">

<div className=" col-4 ">
    <div><img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-icon4.png" alt="" style={{height:'70px',width:'70px'}} /> </div>
    <div className="fw-700 fs-14 plus  pt-2" style={{color:'rgba(79, 79, 79, 1)'}}>Education <br/>
                        & LMS</div>


</div>

<div className=" col-4  ">
    <div><img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-icon5.png" alt="" style={{height:'70px',width:'70px'}} /> </div>
    <div className="fw-700 fs-14 plus  pt-2" style={{color:'rgba(79, 79, 79, 1)'}}>Social Media <br/>
                        & Community </div>


</div>

<div className=" col-4  ">
    <div><img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-icon-6.png" alt="" style={{height:'70px',width:'70px'}} /> </div>
    <div className="fw-700 fs-14 plus  pt-2" style={{color:'rgba(79, 79, 79, 1)'}}>Hotel &  <br/> Hospitality 
   </div>


</div>

</div>


</div>
</div>

  </div>
</section>



<section className=" Mobg1 " style={{overflow:'hidden',marginTop:'60px'}}>
            <div className="container pt-4 pb-5">
                <p className="fw-800 plus fs-35 text-center font-25" style={{color:'white'}}>Why Choose Our Mobile App Development Company in India?</p>
        <div className="hideinmo">
                <div className="row justify-content-center mt-lg-4 g-0 g-2 ">
                    <div className="col-lg-3 col-12 col-md-3">
                        <div className="text-center p-4 h-100" style={{borderRadius:'10px'}}>
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Us-icon9.svg" alt="" />
                            <p className="fw-700 fs-20 plus pt-2" style={{color:'white'}}>Affordable Pricing</p>
                            <p className="fw-500 fs-15 plus " style={{color:'rgba(255, 255, 255, 0.73)'}}>Hire dedicated website developers starting at just $20/hour.</p>

                        </div>

                    </div>

                    <div className="col-lg-3 col-12 col-md-3">
                        <div className="text-center p-lg-4 h-100" style={{borderRadius:'10px'}}>
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Us-icon10.svg" alt="" />
                            <p className="fw-700 fs-20 plus pt-2" style={{color:'white'}}>Global Clientele</p>
                            <p className="fw-500 fs-15 plus " style={{color:'rgba(255, 255, 255, 0.73)'}}>Trusted by clients across different regions.</p>

                        </div>

                    </div>

                    <div className="col-lg-3 col-12 col-md-3">
                        <div className="text-center p-lg-4 h-100" style={{borderRadius:'10px'}}>
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Us-icon11.svg" alt="" />
                            <p className="fw-700 fs-20 plus pt-2" style={{color:'white'}}>Proven Track Record</p>
                            <p className="fw-500 fs-15 plus " style={{color:'rgba(255, 255, 255, 0.73)'}}>Over 100+ projects completed for startups and enterprises.</p>

                        </div>

                    </div>
                </div>

                <div className="row justify-content-center pt-2 g-0 g-2">
                    <div className="col-lg-3 col-12 col-md-3">
                        <div className="text-center p-lg-4 h-100" style={{borderRadius:'10px'}}>
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Us-icon9.svg" alt="" />
                            <p className="fw-700 fs-20 plus pt-2" style={{color:'white'}}>Cutting-Edge Technology</p>
                            <p className="fw-500 fs-15 plus " style={{color:'rgba(255, 255, 255, 0.73)'}}>We stay updated with the latest trends to deliver innovative solutions.</p>

                        </div>

                    </div>

                    <div className="col-lg-3 col-12 col-md-3">
                        <div className="text-center p-4 h-100" style={{borderRadius:'10px'}}>
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Us-icon10.svg" alt="" />
                            <p className="fw-700 fs-20 plus pt-2" style={{color:'white'}}>24 / 7 Support</p>
                            <p className="fw-500 fs-15 plus " style={{color:'rgba(255, 255, 255, 0.73)'}}>Our team is always available to assist you via Teams, Skype, email, or Zoom.</p>

                        </div>

                    </div>

                
                </div>
                </div>

{/* Mobile view  */}
<div className="mt-4">
                <MoSlider/>
                </div>

            </div>
        </section>


<section>
    <div className=" px-3 pt-4 pb-5 " style={{backgroundColor:'rgba(0, 83, 154, 1)'}}>
        <div className="container">
            <div className="row justify-content-center align-items-center">
                <div className="col-lg-7 col-12">
                    <p className="fs-50 plus fw-800 font-25" style={{color:'rgba(255, 255, 255, 1)'}}>Looking to Accelerate Your Mobile App Development?</p>
                </div>
                <div className="col-lg-4 col-12">
                <div className="textcenter">
                <a href="#formsection">
                    <button type="button" className="btn btn-sm font-14  pt-2  px-4 mt-3" style={{fontSize:'20px',fontWeight:'600',backgroundColor:'rgba(255, 255, 255, 1)',borderRadius:'45px',border:'none',outline:'none',paddingBottom:'10px'}}>
                    Discover how we can help
                    </button>
                </a>
            </div>
                    </div>
            </div>
        </div>
    </div>
</section>







   


       
<section className="mt-5">

<section className='d-none d-sm-none d-lg-block d-md-block'>

<div >
        <p className="fs-35 fw-700 plus text-center mb-0 font-20">Key Steps in Our Mobile App Development Process</p>
        <p className="fw-500 fs-16 plus text-center pt-2" style={{color:'rgba(0, 0, 0, 0.6)'}}> Tailored to your needs and budget, we use top practices to build mobile app solutions quickly and efficiently.<br/> Enjoy a smooth mobile app development process with clear communication with our professional team.</p>
        {/* <p className="fs-35 fw-700 plus text-center font-20"> Process from Concept to Launch</p> */}

 </div>
 <div className="container mt-lg-5 ">
<div className="row ms-lg-5">
  <div className="col-lg-4 ">
    <div className="d-flex  gap-2">
      <div>
        <img src={sec5dot1} alt=""  />
      </div>
      <div>
        <p className="sec5title mb-0 mt-1">
          1. Discovery and Planning
        </p>
        <p
          style={{ paddingLeft: "17px !important" }}
          className="para1"
        >
         Understanding your goals, target audience, and requirements to  lay a solid foundation for the project.
        </p>
      </div>
    </div>
  </div>
  <div className="col-lg-4">
    <div className="d-flex  gap-2">
      <div>
        <img src={sec5dot2} alt="" />
      </div>
      <div>
        <p className="sec5title mb-0 mt-1">2. Design</p>
        <p
          style={{ paddingLeft: "17px !important" }}
          className="para1"
        >
          Bringing your vision to life with captivating visuals and
          intuitive user interfaces.
        </p>
      </div>
    </div>
  </div>
  <div className="col-lg-4">
    <div className="d-flex  gap-2">
      <div>
        <img src={sec5dot1} alt="" />
      </div>
    
      <div>
        <p className="sec5title mb-0 mt-1">3. Development</p>
        <p
          style={{ paddingLeft: "17px !important" }}
          className="para1"
        >
          Transforming designs into functional <br /> websites with
          clean code and seamless functionality.
        </p>
      </div>
    </div>
  </div>
</div>
</div>
<div className="container">

<div className="col-lg-12 ms-lg-5">
<img className="img-fluid" src={stagesbg} alt="" />
</div>
</div>
<div className="container pt-4 ">
<div className="row ms-lg-5">
  <div className="col-lg-4">
    <div className="d-flex  gap-2">
      <div>
        <img src={sec5dot3} alt="" />
      </div>
      <div>
        <p className="sec5title mb-0 mt-1">4. Testing </p>
        <p
          style={{ paddingLeft: "17px !important" }}
          className="para1"
        >
          Thoroughly checking every aspect of the website to ensure
          it meets quality standards and performs flawlessly.
        </p>
      </div>
    </div>
  </div>
  <div className="col-lg-4">
    <div className="d-flex  gap-2">
      <div>
        <img src={sec5dot4} alt="" />
      </div>
     
      <div>
        <p className="sec5title mb-0 mt-1">5. Launch</p>
        <p
          style={{ paddingLeft: "17px !important" }}
          className="para1"
        >
          Deploying the website to the live <br /> environment and
          making it accessible to your audience.
        </p>
      </div>
    </div>
  </div>
  <div className="col-lg-4">
    <div className="d-flex  gap-2">
      <div>
        <img src={sec5dot3} alt="" />
      </div>
      <div>
        <p className="sec5title mb-0 mt-1">6. Beyond</p>
        <p
          style={{ paddingLeft: "17px !important" }}
          className="para1"
        >
          Providing ongoing support, maintenance, and updates to
          ensure your website remains optimized and up to date.
        </p>
      </div>
    </div>
  </div>
</div>



</div>
    
</section>

{/* mobile view */}
<section className='d-block d-sm-block d-lg-none d-md-none'>
  <div className='container mt-4 '>
  <p className="fs-35 fw-700 plus text-center mb-0 font-20">Key Steps in Our Mobile App Development Process</p>

    <div className='row justify-content-center'>
      {/* <div className='col-3'>
         <img style={{height:'532px'}} src="/assets/" alt="" className="img-fluid" />
      </div> */}
      <div className='col-10 mt-4'>
        <div className="d-flex  gap-2">
          <div>
            <img src={sec5dot1} alt=""  />
          </div>
          <div>
            <p className="sec5title fs-15 mb-0 mt-1">
              1. Discovery and Planning
            </p>
            <p
              style={{ paddingLeft: "17px !important" }}
              className="para1 fs-12 "
            >
            Understanding your goals, target audience, and requirements to  lay a solid foundation for the project.
            </p>
          </div>
        </div>
        <div className="d-flex  gap-2">
          <div>
            <img src={sec5dot2} alt="" />
          </div>
        
          <div>
            <p className="sec5title mb-0 mt-1 fs-15">2. Design</p>
            <p
              style={{ paddingLeft: "17px !important" }}
              className="para1 fs-12"
            >
              Bringing your vision to life with captivating visuals and
              intuitive user interfaces.
            </p>
          </div>
        </div>
        <div className="d-flex  gap-2">
          <div>
            <img src={sec5dot1} alt="" />
          </div>
        

          <div>
            <p className="sec5title mb-0 mt-1 fs-15">3. Development </p>
            <p
              style={{ paddingLeft: "17px !important" }}
              className="para1 fs-12"
            >
              Transforming designs into functional <br /> websites with
              clean code and seamless functionality.
            </p>
          </div>
        </div>
        <div className="d-flex  gap-2">
          <div>
            <img src={sec5dot3} alt="" />
          </div>
       
          <div>
            <p className="sec5title mb-0 mt-1 fs-15">4. Testing </p>
            <p
              style={{ paddingLeft: "17px !important" }}
              className="para1 fs-12"
            >
              Thoroughly checking every aspect of the website to ensure
              it meets quality standards and performs flawlessly.
            </p>
          </div>
        </div>
        <div className="d-flex  gap-2">
          <div>
            <img src={sec5dot4} alt="" />
          </div>
       
          <div>
            <p className="sec5title mb-0 mt-1 fs-15">5. Launch</p>
            <p
              style={{ paddingLeft: "17px !important" }}
              className="para1 fs-12"
            >
              Deploying the website to the live <br /> environment and
              making it accessible to your audience.
            </p>
          </div>
        </div>
        <div className="d-flex  gap-2">
          <div>
            <img src={sec5dot3} alt="" />
          </div>
          <div>
            <p className="sec5title mb-0 mt-1 fs-15">6. Beyond</p>
            <p
              style={{ paddingLeft: "17px !important" }}
              className="para1 fs-12"
            >
              Providing ongoing support, maintenance, and updates to
              ensure your website remains optimized and up to date.
            </p>
          </div>
        </div>
      </div>
    </div>
    

  </div>
</section>

</section>

<section>
  <div className="container my-lg-5 mt-20">
    <div className="row align-items-center justify-content-center textcenter">
      <div className="col-lg-5">
        <p className="fs-70 fw-800 plus font-25" style={{color:'rgba(0, 83, 154, 1)'}}>How it Works </p>

      </div>
      <div className="col-lg-7 text-center">
        <div className="pt-10 ">
          <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/How-it-works.png" alt="" className="img-fluid " />
        </div>
        <div className="textcenter mt-4 mt-40">
                <a href="#formsection">
                    <button type="button" className="btn btn-sm font-14  pt-2  px-4" style={{fontSize:'20px',fontWeight:'600',backgroundColor:'rgba(0, 83, 154, 1)',borderRadius:'45px',border:'none',outline:'none',paddingBottom:'10px',color:'rgba(255, 255, 255, 1)'}}>
                    Get a Free Quote Now  
                    </button>
                </a>
            </div>

      </div>
    </div>

  </div>
</section>



<section>
  <div className="container my-5">
    <p className="fs-35 fw-800 plus text-center font-25" style={{color:'rgba(26, 26, 26, 1)'}}>Industry - Leading Technologies We Utilized</p>
<div className="row justify-content-center">
  <div className="col-lg-8">
    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/TechStack-img.png" alt="" className="img-fluid mt-4" />

  </div>
</div>
  </div>
</section>

    <section>
                <div className="container mt-lg-5 mt-20">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-12 col-md-6">
                        <div className="text-center">
                                  <p className="fw-800 fs-33 plus font-23 " style={{color:'#1B3567'}}>What We Believe in</p>
                                {/* <p className="fw-500 fs-16 plus px-lg-5 " style={{color:'#000000',lineHeight:'30px'}}>We Committed To Delivering High-Quality Projects With a Strong Focus On On-Time Delivery. Our Team Prioritizes Efficient Workflows, Clear Communication, And Tailored Solutions To Ensure Every Project Is Completed Within The Agreed Timeline, Meeting And Exceeding Client Expectations</p> */}
                                <p className="fw-500 fs-16 plus " style={{color:'rgba(0, 0, 0, 0.6)',lineHeight:'25px'}}>We are committed to delivering high-quality projects with a strong focus on on-time delivery. Our team prioritizes efficient workflows, clear communication, and tailored solutions to ensure every project is completed within the agreed timeline, meeting and exceeding client expectations.</p>

                        </div>
                        </div>
                    </div>
                </div>
    </section>

            <section>
                <div className="container mt-4">
                    <div className="row g-2">
                        <div className="col-lg-3 col-12 col-md-6 textcenter">
                        <div className="box-shadow1 h-100">
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-icon2.svg" alt="" />
                            <p className="fw-800 fs-20 plus mb-0 mt-4" style={{color:'#00539A'}}>Security</p>
                            <p className="fw-500 plus fs-16 mt-3" style={{color:'#7C7C7C'}}>Our aim is to bring a new approach to secure your software based on integrity, trust and transparency</p>

                        </div>
                        </div>

                        <div className="col-lg-3 col-12 col-md-6 textcenter">
                        <div className="box-shadow1 h-100">
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-icon3.svg" alt="" />
                            <p className="fw-800 fs-20 plus mb-0 mt-4" style={{color:'#00539A'}}>Support</p>
                            <p className="fw-500 plus fs-16 mt-3" style={{color:'#7C7C7C'}}>The best gift is time, and our 24/7 dedicated support team is always available to address your queries and concerns.</p>

                        </div>
                        </div>

                        <div className="col-lg-3 col-12 col-md-6 textcenter">
                        <div className="box-shadow1 h-100">
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-icon4.svg" alt="" />
                            <p className="fw-800 fs-20 plus mb-0 mt-4" style={{color:'#00539A'}}>Integrity</p>
                            <p className="fw-500 plus fs-16 mt-3" style={{color:'#7C7C7C'}}>Our expert team offers the best advice tailored to your product. We ensure guidance that drives success.</p>

                        </div>
                        </div>

                        <div className="col-lg-3 col-12 col-md-6 textcenter">
                        <div className="box-shadow1 h-100">
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-icon5.svg" alt="" />
                            <p className="fw-800 fs-20 plus mb-0 mt-4" style={{color:'#00539A'}}>Transparency</p>
                            <p className="fw-500 plus fs-16 mt-3" style={{color:'#7C7C7C'}}>Transparency means embracing new ideas, technology, and approaches. We firmly believe in fostering learning and openness.</p>

                        </div>
                        </div>
                    </div>
                </div>
            </section>



  <div id="formsection">

</div>

      
<section  className=" d-none d-sm-none d-md-block d-lg-block" style={{marginTop:'7%'}}>
   <NewForm/>

</section>

{/* Mobile View  */}
<section className="mt-lg-4 d-block d-sm-block d-md-none d-lg-none">
    <div className=" pt-3 pb-5 px-2 mt-30" style={{backgroundColor:'rgba(242, 242, 242, 1)'}}>
        <div className="container">
         
                      <p className="fw-600 text-center fs-23 plus mb-0 pt-1" >What can we help you with?</p>
                      <p className="fw-500 text-center fs-17 plus pt-3" style={{lineHeight:'22px'}}>Get Custom Solutions, Recommendations, or, Estimates.
                      Confidentiality & Same Day Response Guaranteed!</p>
    <div className="pt-1">
       <Form/>
    </div>

    <div className="d-flex justify-content-center gap-2 mt-4 ">

<div className="d-flex  gap-2">
    <div>
          <img src= "https://d3vqz9qyn2r1xe.cloudfront.net/imges/green-icon-form.svg" alt="" className="pt-1" />
    </div>
    <div>
           <p className="fw-600 plus fs-17  pt-1">100% Confidential</p>
    </div>
</div>

<div className="d-flex  gap-2">
    <div>
          <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/green-icon-form.svg" alt="" className="pt-1" />
    </div>
    <div>
           <p className="fw-600 plus fs-17  pt-1">We sign NDA</p>
    </div>
</div>

</div>

<div className="d-flex gap-4 mt-4">
            <div>
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/formicon1.svg" alt="" className="img-fluid" />
            </div>
            <div>
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/formicon2.svg" alt="" className="img-fluid" />
            </div>
            <div>
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/formicon3.svg" alt="" className="img-fluid pt-1" />
            </div>
            <div>
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/formicon4.svg" alt="" className="img-fluid" />
            </div>
            <div>
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/formicon5.svg" alt="" className="img-fluid" />
            </div>
            <div>
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/formicon6.svg" alt="" className="img-fluid pt-2" />
            </div>
    </div>

      </div>
      </div>
</section>



{/* <section className="mt-5">
    <GoogleReviewsWidget/>
</section> */}

<section className="my-lg-5">
  <div className="container-fluid">
    <GoogleReviewsWidget2/>
    </div>
</section>






        <section style={{backgroundColor:'rgba(208, 233, 255, 1)'}}>
      <div className=" pt-5 pb-4">
          <Faqaccordian faqAccordianData={faqDatamobile}/>
          </div>
      </section>



        <section >
                <Footer/>
        </section>

    </div>
);
};
export default MobileDevlopmentPage;